/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import DashboardListingDisplayCard from "../components/DashboardListingsDisplayCard";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { STYLES } from "config";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Container,
} from "reactstrap";

import CreateListingsDashboardModal from "../components/CreateListingDashboardModal";
import CreateEnquiryDashboardModal from "components/CreateEnquiryDashboardModal";
import CreateRegionModal from "components/CreateRegionModal";
import CreateAreaDashboardModal from "components/CreateAreaDashboardModal";

// Import chart components
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line
} from 'recharts';

// Custom chart components
const ListingAnalyticsChart = ({ data, chartType }) => {
  if (chartType === 'bar') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="listings" fill={STYLES.PRIMARY_APP_CLR} />
        </BarChart>
      </ResponsiveContainer>
    );
  } else if (chartType === 'pie') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  } else {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="listings" stroke={STYLES.PRIMARY_APP_CLR} activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    );
  }
};

const EnquiryAnalyticsChart = ({ data, chartType }) => {
  if (chartType === 'bar') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="enquiries" fill={STYLES.SECONDARY_APP_CLR} />
        </BarChart>
      </ResponsiveContainer>
    );
  } else if (chartType === 'pie') {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  } else {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="enquiries" stroke={STYLES.SECONDARY_APP_CLR} activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    );
  }
};

const Dashboard = () => {
  const [mylocation, setMylocation] = useState(null);
  const [locations, setLocations] = useState([]);
  const [dailygross, setDailygross] = useState(0);
  const [monthlygross, setMonthlygross] = useState(0);
  const [totalgross, setTotalgross] = useState(0);
  const [currentBranch, setCurrentBranch] = useState({});
  const [settings, setSettings] = useState({});

  // State tracking for listings and enquiries
  const [listingStats, setListingStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    byStatus: [],
    byCategory: [],
    monthlyTrend: []
  });

  const [enquiryStats, setEnquiryStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    byStatus: [],
    byType: [],
    monthlyTrend: []
  });

  // Chart type state
  const [listingChartType, setListingChartType] = useState('bar');
  const [enquiryChartType, setEnquiryChartType] = useState('bar');

  const usersdata = useSelector((state) => state.usersdata);
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const settingsdata = useSelector((state) => state.settingsdata);
  const auth = useSelector((state) => state.auth);
  const areaData = useSelector((state) => state.areaData);
  const regionData = useSelector((state) => state.regionData);

  const { api } = useContext(FirebaseContext);
  const {
    get_Branch_By_Name,
    fetchBranchesEnquiries,
    fetchAllBranchListings,
    fetchCurrentAdminsBranchListings,
    fetchCurrentAdminsBranchEnquiries,
    clearListingErrors,
    clearEnquiryErrors
  } = api;

  const navigate = useNavigate();
  const location = useLocation();
  let branch = auth.info.profile.adminHomeOffice
    ? auth.info.profile.adminHomeOffice
    : auth.info.profile.brokerHomeOffice;
  const dispatch = useDispatch();

  const brokers = useSelector((state) => state.brokers.users);
  const listings = useSelector((state) => state.ListingData.listingsByBranch);
  const branchManagementReducer = useSelector((state) => state.branchData);
  const activeListingsByBranch = useSelector(
    (state) => state.ListingData.activeListingsByBranch
  );
  const inactiveListingsByBranch = useSelector(
    (state) => state.ListingData.inactiveListingsByBranch
  );
  const enquiryManagementReducer = useSelector((state) => state.enquirydata);
  const branchEnquiries = useSelector(
    (state) => state.enquirydata.branchEnquirries
  );
  const activeBranchEnquiries = useSelector(
    (state) => state.enquirydata.activeBranchEnquiries
  );
  const inactiveBranchEnquiries = useSelector(
    (state) => state.enquirydata.inactiveBranchEnquiries
  );

  const [branches, setBranches] = useState(location.state);
  const [brokerList, setBrokerList] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [regionReducerData, setRegionReducerData] = useState([]);

  // Process listing data for analytics



  // Color generator function
  const generateColorFromName = (name) => {
    // Hash the name to get a consistent number
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Generate HSL color with fixed saturation and lightness for good contrast
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 60%)`;
  };

  useEffect(() => {
    if (activeListingsByBranch && inactiveListingsByBranch) {
      const total = activeListingsByBranch.length + inactiveListingsByBranch.length;
      const allListings = [...activeListingsByBranch, ...inactiveListingsByBranch];

      const statusCount = {};
      allListings.forEach(listing => {
        const status = listing.status || 'Unknown';
        statusCount[status] = (statusCount[status] || 0) + 1;
      });

      const byStatus = Object.keys(statusCount).map(status => ({
        name: status,
        value: statusCount[status],
        color: generateColorFromName(status)
      }));

      // Calculate listings by category
      const categoryCount = {};
      allListings.forEach(listing => {
        if (listing?.userdetials?.Name && listing?.userdetials?.lastName) {
          const category = `${listing.userdetials.Name} ${listing.userdetials.lastName}.` || 'Uncategorized';
          categoryCount[category] = (categoryCount[category] || 0) + 1;
        }

      });




      const byCategory = Object.keys(categoryCount).map(category => ({
        name: category,
        listings: categoryCount[category]
      }));

      // Generate monthly trend data for last 6 months
      const now = new Date();
      const monthlyTrend = [];

      // Create an array for the last 6 months
      for (let i = 5; i >= 0; i--) {
        const monthDate = new Date();
        monthDate.setMonth(now.getMonth() - i);

        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();

        // Get the start and end timestamps for this month
        const startOfMonth = new Date(year, month, 1).getTime();
        const endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();

        // Count listings created in this month
        const listingsThisMonth = allListings.filter(listing => {
          const createdAt = listing.CreatedAt || listing.createdAt || 0;
          return createdAt >= startOfMonth && createdAt <= endOfMonth;
        }).length;

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        monthlyTrend.push({
          name: `${monthNames[month]} ${year.toString().slice(2)}`,
          month: month,
          year: year,
          listings: listingsThisMonth,
          fullDate: monthDate
        });
      }

      setListingStats({
        total,
        active: activeListingsByBranch.length,
        inactive: inactiveListingsByBranch.length,
        byStatus,
        byCategory,
        monthlyTrend
      });
    }
  }, [activeListingsByBranch, inactiveListingsByBranch]);
  // Process enquiry data for analytics
  useEffect(() => {
    if (activeBranchEnquiries && inactiveBranchEnquiries) {
      const total = (activeBranchEnquiries?.length || 0) + (inactiveBranchEnquiries?.length || 0);
      const allEnquiries = [...activeBranchEnquiries, ...inactiveBranchEnquiries];
      // Calculate enquiries by status
      const byStatus = [
        { name: 'Active', value: activeBranchEnquiries?.length || 0, color: STYLES.SECONDARY_APP_CLR },
        { name: 'Inactive', value: inactiveBranchEnquiries?.length || 0, color: '#6c757d' }
      ];

      // Calculate enquiries by type (example - you might need to adjust based on your data structure)
      const typeCount = {};
      [...(activeBranchEnquiries || []), ...(inactiveBranchEnquiries || [])].forEach(enquiry => {
        if (enquiry?.userdetials?.Name && enquiry?.userdetials?.lastName) {
          const type = `${enquiry.userdetials.Name} ${enquiry.userdetials.lastName}.` || 'General';
          typeCount[type] = (typeCount[type] || 0) + 1;
        }
      });

      const byType = Object.keys(typeCount).map(type => ({
        name: type,
        enquiries: typeCount[type]
      }));

      // Generate monthly trend data for last 6 months
      const now = new Date();
      const monthlyTrend = [];

      // Create an array for the last 6 months
      for (let i = 5; i >= 0; i--) {
        const monthDate = new Date();
        monthDate.setMonth(now.getMonth() - i);

        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();

        // Get the start and end timestamps for this month
        const startOfMonth = new Date(year, month, 1).getTime();
        const endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();

        // Count listings created in this month
        const enquiriesThisMonth = allEnquiries.filter(listing => {
          const createdAt = listing.enquiryDate || listing.enquiryDate || 0;
          return createdAt >= startOfMonth && createdAt <= endOfMonth;
        }).length;

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        monthlyTrend.push({
          name: `${monthNames[month]} ${year.toString().slice(2)}`,
          month: month,
          year: year,
          enquiries: enquiriesThisMonth,
          fullDate: monthDate
        });
      }
      setEnquiryStats({
        total,
        active: activeBranchEnquiries?.length || 0,
        inactive: inactiveBranchEnquiries?.length || 0,
        byStatus,
        byType,
        monthlyTrend
      });
    }
  }, [activeBranchEnquiries, inactiveBranchEnquiries]);

  useEffect(() => {
    if (regionData.regions) {
      setRegionReducerData(regionData.regions);
    }
    dispatch(clearListingErrors());
  }, [regionData.regions]);

  useEffect(() => {
    if (mylocation == null) {
      navigator.geolocation.getCurrentPosition(
        (position) =>
          setMylocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        (err) => console.log(err)
      );
    }
  }, [mylocation]);

  useEffect(() => {
    if (usersdata.users) {
      setAdminList(
        usersdata.admins.filter((user) => user.userType === "admin")
      );
    } else {
      setAdminList(usersdata.admins);
    }
  }, [usersdata.users]);

  useEffect(() => {
    if (settingsdata.settings) {
      setSettings(settingsdata.settings);
    }
  }, [settingsdata.settings]);

  useEffect(() => {
    if (branchManagementReducer.branches) {
      for (
        let index = 0;
        index < branchManagementReducer.branches.length;
        index++
      ) {
        if (
          branchManagementReducer.branches[index].BranchName ===
          auth.info.profile.adminHomeOffice
        ) {
          setCurrentBranch(branchManagementReducer.branches[index]);
        }
      }
      if (currentBranch && auth.info.profile.adminHomeOffice) {
        dispatch(fetchCurrentAdminsBranchEnquiries());
      }

      if (currentBranch && auth.info.profile.brokerHomeOffice) {
        dispatch(fetchBranchesEnquiries(branch));
      }
    }
  }, []);

  useEffect(() => {
    if (usersdata.users) {
      const brokers = usersdata.users.filter(
        (user) =>
          user.userType === "broker" &&
          (auth.info.profile.userType === "landlord" ||
            auth.info.profile.userType === "admin")
      );
      let locs = [];
      if (brokers) {
        for (let i = 0; i < brokers.length; i++) {
          if (
            brokers[i].approved &&
            brokers[i].brokerActiveStatus &&
            brokers[i].location
          ) {
            locs.push({
              id: i,
              lat: brokers[i].location.lat,
              lng: brokers[i].location.lng,
              brokername: brokers[i].firstName + " " + brokers[i].lastName,
            });
          }
        }
      }
      setLocations(locs);
    }
  }, [usersdata.users, auth.info.profile, auth.info.uid]);

  useEffect(() => {
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === branch) {
          arr.push(element);
        }
      }

      setBrokerList(
        arr.sort((a, b) => a?.username?.localeCompare(b?.username))
      );
    }
  }, [brokers]);

  if (!branch) {
    return (
      <div style={{
        textAlign: "center",
        padding: "40px 20px",
        backgroundColor: "#f8f9fa",
        minHeight: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <h1 style={{
          color: "#6c757d",
          marginBottom: "20px",
          fontWeight: "600"
        }}>
          No Branch Selected
        </h1>
        <Button
          variant="contained"
          style={{
            backgroundColor: STYLES.SECONDARY_APP_CLR,
            color: "white",
            padding: "10px 20px",
            borderRadius: "6px",
            fontWeight: "600"
          }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </div>
    );
  }

  useEffect(() => {
    if (bookinglistdata.bookings) {
      let today = new Date();
      let convenniencefees = 0;
      let totconvenienceTrans = 0;
      let todayConvenience = 0;
      for (let i = 0; i < bookinglistdata.bookings.length; i++) {
        if (
          bookinglistdata.bookings[i].status === "PAID" ||
          bookinglistdata.bookings[i].status === "COMPLETE"
        ) {
          const { eventdate, convenience_fees } = bookinglistdata.bookings[i];
          let tDate = new Date(eventdate);
          if (convenience_fees > 0) {
            if (
              tDate.getMonth() === today.getMonth() &&
              tDate.getFullYear() === today.getFullYear()
            ) {
              convenniencefees =
                convenniencefees + parseFloat(convenience_fees);
            }
            if (
              tDate.getDate() === today.getDate() &&
              tDate.getMonth() === today.getMonth()
            ) {
              todayConvenience =
                todayConvenience + parseFloat(convenience_fees);
            }
            totconvenienceTrans =
              totconvenienceTrans + parseFloat(convenience_fees);
          }
        }
      }
      setDailygross(parseFloat(todayConvenience).toFixed(2));
      setMonthlygross(parseFloat(convenniencefees).toFixed(2));
      setTotalgross(parseFloat(totconvenienceTrans).toFixed(2));
    }
  }, [bookinglistdata.bookings]);

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <div style={{ padding: "10px", backgroundColor: "#f5f7f9", minHeight: "100vh" }}>
      <CardBody style={{ padding: "2px" }}>
        <Container>
          {!branch ? (
            <div style={{
              textAlign: "center",
              padding: "40px 20px"
            }}>
              <h1 style={{
                color: "#6c757d",
                marginBottom: "20px"
              }}>
                No Branch Selected
              </h1>
              <Button
                variant="contained"
                style={{
                  backgroundColor: STYLES.SECONDARY_APP_CLR,
                  color: "white"
                }}
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>
            </div>
          ) : (
            <Row>
              <Col md="12">
                <Card
                  style={{
                    border: "none",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
                  }}
                >
                  <CardHeader
                    style={{
                      backgroundColor: "transparent",
                      borderBottom: `2px solid ${STYLES.PRIMARY_APP_CLR}`,
                      padding: "16px 20px"
                    }}
                  >
                    <CardTitle
                      tag="h4"
                      style={{
                        color: STYLES.SECONDARY_APP_CLR,
                        fontWeight: "700",
                        margin: 0,
                        fontSize: "1.3rem",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {currentBranch.BranchName} Branch Details

                      <i
                        className="now-ui-icons loader_gear"
                        onClick={() => navigate("/settings")}
                        style={{
                          fontSize: 28,
                          cursor: "pointer",
                          color: STYLES.PRIMARY_APP_CLR,
                          transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.target.style.transform = "rotate(30deg)"}
                        onMouseLeave={(e) => e.target.style.transform = "rotate(0deg)"}
                      />
                    </CardTitle>
                  </CardHeader>
                  <CardBody style={{ padding: "20px" }}>
                    <Row>
                      <Col md="6" style={{ marginBottom: "16px" }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons users_single-02"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "12px"
                            }}
                          />
                          <p style={{
                            fontWeight: "600",
                            margin: 0,
                            color: "#495057"
                          }}>
                            <strong style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              Manager:
                            </strong>{" "}
                            {currentBranch.admin || "Not assigned"}
                          </p>
                        </div>
                      </Col>
                      <Col md="6" style={{ marginBottom: "16px" }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons location_pin"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "12px"
                            }}
                          />
                          <p style={{
                            fontWeight: "600",
                            margin: 0,
                            color: "#495057"
                          }}>
                            <strong style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              Address:
                            </strong>{" "}
                            {currentBranch.address || "Not available"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6" style={{ marginBottom: "16px" }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons tech_mobile"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "12px"
                            }}
                          />
                          <p style={{
                            fontWeight: "600",
                            margin: 0,
                            color: "#495057"
                          }}>
                            <strong style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              Contact Info:
                            </strong>{" "}
                            {currentBranch.contactInfo || "Not provided"}
                          </p>
                        </div>
                      </Col>
                      <Col md="6" style={{ marginBottom: "16px" }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons location_compass-05"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "12px"
                            }}
                          />
                          <p style={{
                            fontWeight: "600",
                            margin: 0,
                            color: "#495057"
                          }}>
                            <strong style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              Province:
                            </strong>{" "}
                            {currentBranch.Province || "Not specified"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons ui-1_calendar-60"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "12px"
                            }}
                          />
                          <p style={{
                            fontWeight: "600",
                            margin: 0,
                            color: "#495057"
                          }}>
                            <strong style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              Date:
                            </strong>{" "}
                            {currentBranch.createdAt ?
                              moment(currentBranch.createdAt).format("MMMM Do YYYY") :
                              "Not available"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </CardBody>

      <Row>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer spacing={3}>
            <GridItem xs={12} sm={6} md={6} lg={6}>
              <DashboardListingDisplayCard
                title="Listings"
                style={{ borderRadius: "12px", overflow: "hidden" }}
              >
                <Row style={{ marginBottom: "16px" }}>
                  <Col md="12">
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px"
                    }}>
                      <i
                        className="now-ui-icons design-2_ruler-pencil"
                        style={{
                          fontSize: "20px",
                          color: STYLES.PRIMARY_APP_CLR,
                          marginRight: "10px"
                        }}
                      />
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Total Listings:{" "}
                        <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                          {activeListingsByBranch.length + inactiveListingsByBranch.length}
                        </span>
                      </span>
                    </div>
                  </Col>
                </Row>

                <CardFooter
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "0 0 12px 12px"
                  }}
                >
                  <div
                    onClick={() => {
                      dispatch(clearListingErrors());
                      navigate('/createStock')
                    }}
                    style={{
                      backgroundColor: STYLES.PRIMARY_APP_CLR,
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.1)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  >
                    <span style={{ color: "white", fontSize: "30px", lineHeight: "45px" }}>+</span>
                  </div>

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: STYLES.SECONDARY_APP_CLR,
                      color: "white",
                      margin: "0 8px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      padding: "8px 16px"
                    }}
                    onClick={() => {
                      console.log("Active Listings:", activeListingsByBranch);
                      if (auth.info.profile.adminHomeOffice === branch) {
                        navigate("/stock", {
                          state: "Active",
                        });
                      } else {
                        alert(
                          "You do not have permission to view this content"
                        );
                      }
                    }}
                  >
                    Active: {activeListingsByBranch.length}
                  </Button>

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      margin: "0 8px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      padding: "8px 16px"
                    }}
                    onClick={() => {
                      if (auth.info.profile.adminHomeOffice === branch) {
                        navigate("/stock", {
                          state: "inActive",
                        });
                      } else {
                        alert(
                          "You do not have permission to view this content"
                        );
                      }
                    }}
                  >
                    Archived: {inactiveListingsByBranch.length}
                  </Button>
                </CardFooter>
              </DashboardListingDisplayCard>
            </GridItem>

            <GridItem xs={12} sm={6} md={6} lg={6}>
              <DashboardListingDisplayCard
                title="ENQUIRIES"
                style={{ borderRadius: "12px", overflow: "hidden" }}
              >
                <Row style={{ marginBottom: "16px" }}>
                  <Col md="12">
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px"
                    }}>
                      <i
                        className="now-ui-icons ui-1_email-85"
                        style={{
                          fontSize: "20px",
                          color: STYLES.PRIMARY_APP_CLR,
                          marginRight: "10px"
                        }}
                      />
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Total Branch Enquiries:{" "}
                        <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                          {activeBranchEnquiries?.length + inactiveBranchEnquiries?.length}
                        </span>
                      </span>
                    </div>
                  </Col>
                </Row>

                <CardFooter
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "0 0 12px 12px"
                  }}
                >
                  <div
                    onClick={() => {
                      dispatch(clearEnquiryErrors())
                      navigate('/createEnquiry')
                    }}
                    style={{
                      backgroundColor: STYLES.PRIMARY_APP_CLR,
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.1)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  >
                    <span style={{ color: "white", fontSize: "30px", lineHeight: "45px" }}>+</span>
                  </div>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: STYLES.SECONDARY_APP_CLR,
                      color: "white",
                      margin: "0 8px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      padding: "8px 16px"
                    }}
                    onClick={() => {
                      if (auth.info.profile.adminHomeOffice === branch) {
                        navigate("/enquiries", {
                          state: "Active",
                        });
                      } else {
                        alert(
                          "You do not have permission to view this content"
                        );
                      }
                    }}
                  >
                    Active: {activeBranchEnquiries?.length}
                  </Button>

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      margin: "0 8px",
                      borderRadius: "6px",
                      fontWeight: "600",
                      padding: "8px 16px"
                    }}
                    onClick={() => {
                      if (auth.info.profile.adminHomeOffice === branch) {
                        navigate("/enquiries", {
                          state: 'inActive',
                        });
                      } else {
                        alert(
                          "You do not have permission to view this content"
                        );
                      }
                    }}
                  >
                    Archived: {inactiveBranchEnquiries?.length}
                  </Button>
                </CardFooter>
              </DashboardListingDisplayCard>
            </GridItem>

            {/* Analytics Dashboard Section */}
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Card style={{ marginTop: "20px", borderRadius: "10px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)" }}>
                <CardHeader style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white" }}>
                  <CardTitle tag="h4" style={{ margin: 0 }}>
                    Analytics Dashboard
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <div style={{ marginBottom: "20px" }}>
                        <Typography variant="h6" style={{ color: STYLES.SECONDARY_APP_CLR, marginBottom: "15px" }}>
                          Listings Analytics
                        </Typography>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                          <Button
                            variant={listingChartType === 'bar' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: listingChartType === 'bar' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: listingChartType === 'bar' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setListingChartType('bar')}
                          >
                            Bar Chart
                          </Button>
                          <Button
                            variant={listingChartType === 'pie' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: listingChartType === 'pie' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: listingChartType === 'pie' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setListingChartType('pie')}
                          >
                            Pie Chart
                          </Button>
                          <Button
                            variant={listingChartType === 'line' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: listingChartType === 'line' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: listingChartType === 'line' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setListingChartType('line')}
                          >
                            Trend
                          </Button>
                        </div>
                        <div style={{ height: "300px" }}>
                          <ListingAnalyticsChart
                            data={listingChartType === 'pie' ? listingStats.byStatus :
                              listingChartType === 'line' ? listingStats.monthlyTrend :
                                listingStats.byCategory}
                            chartType={listingChartType}
                          />
                        </div>
                        <div style={{ textAlign: "center", marginTop: "10px" }}>
                          <strong>Total: {listingStats.total}</strong> |
                          <span style={{ color: STYLES.SECONDARY_APP_CLR }}> Active: {listingStats.active}</span> |
                          <span style={{ color: "#6c757d" }}> Inactive: {listingStats.inactive}</span>
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div style={{ marginBottom: "20px" }}>
                        <Typography variant="h6" style={{ color: STYLES.SECONDARY_APP_CLR, marginBottom: "15px" }}>
                          Enquiries Analytics
                        </Typography>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                          <Button
                            variant={enquiryChartType === 'bar' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: enquiryChartType === 'bar' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: enquiryChartType === 'bar' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setEnquiryChartType('bar')}
                          >
                            Bar Chart
                          </Button>
                          <Button
                            variant={enquiryChartType === 'pie' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: enquiryChartType === 'pie' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: enquiryChartType === 'pie' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setEnquiryChartType('pie')}
                          >
                            Pie Chart
                          </Button>
                          <Button
                            variant={enquiryChartType === 'line' ? "contained" : "outlined"}
                            size="small"
                            style={{
                              backgroundColor: enquiryChartType === 'line' ? STYLES.SECONDARY_APP_CLR : 'transparent',
                              color: enquiryChartType === 'line' ? 'white' : STYLES.SECONDARY_APP_CLR
                            }}
                            onClick={() => setEnquiryChartType('line')}
                          >
                            Trend
                          </Button>
                        </div>
                        <div style={{ height: "300px" }}>
                          <EnquiryAnalyticsChart
                            data={enquiryChartType === 'pie' ? enquiryStats.byStatus :
                              enquiryChartType === 'line' ? enquiryStats.monthlyTrend :
                                enquiryStats.byType}
                            chartType={enquiryChartType}
                          />
                        </div>
                        <div style={{ textAlign: "center", marginTop: "10px" }}>
                          <strong>Total: {enquiryStats.total}</strong> |
                          <span style={{ color: STYLES.SECONDARY_APP_CLR }}> Active: {enquiryStats.active}</span> |
                          <span style={{ color: "#6c757d" }}> Inactive: {enquiryStats.inactive}</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </GridItem>

            {auth.info.profile.isSuperAdmin ? (
              <>
                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <DashboardListingDisplayCard
                    title="Areas"
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  >
                    <Row style={{ marginBottom: "16px" }}>
                      <Col md="12">
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons location_pin"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "10px"
                            }}
                          />
                          <span style={{ fontSize: "18px", fontWeight: "600" }}>
                            Total Areas:{" "}
                            <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              {areaData.areas.length}
                            </span>
                          </span>
                        </div>
                      </Col>
                    </Row>

                    <CardFooter
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "16px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "0 0 12px 12px"
                      }}
                    >
                      <CreateAreaDashboardModal />

                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: STYLES.SECONDARY_APP_CLR,
                          color: "white",
                          borderRadius: "6px",
                          fontWeight: "600",
                          padding: "8px 16px"
                        }}
                        onClick={() => {
                          console.log("Areas:", areaData.areas.length);
                          if (auth.info.profile.adminHomeOffice === branch) {
                            navigate("/areaManagement", {
                              state: areaData.areas,
                            });
                          } else {
                            alert(
                              "You do not have permission to view this content"
                            );
                          }
                        }}
                      >
                        View Areas
                      </Button>
                    </CardFooter>
                  </DashboardListingDisplayCard>
                </GridItem>

                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <DashboardListingDisplayCard
                    title="Regions"
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  >
                    <Row style={{ marginBottom: "16px" }}>
                      <Col md="12">
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <i
                            className="now-ui-icons location_compass-05"
                            style={{
                              fontSize: "20px",
                              color: STYLES.PRIMARY_APP_CLR,
                              marginRight: "10px"
                            }}
                          />
                          <span style={{ fontSize: "18px", fontWeight: "600" }}>
                            Total Regions:{" "}
                            <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                              {regionReducerData.length}
                            </span>
                          </span>
                        </div>
                      </Col>
                    </Row>

                    <CardFooter
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "16px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "0 0 12px 12px"
                      }}
                    >
                      <CreateRegionModal />

                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: STYLES.SECONDARY_APP_CLR,
                          color: "white",
                          borderRadius: "6px",
                          fontWeight: "600",
                          padding: "8px 16px"
                        }}
                        onClick={() => {
                          console.log("Regions:", regionReducerData.length);
                          if (auth.info.profile.adminHomeOffice === branch) {
                            navigate("/regionmanagement", {
                              state: regionReducerData,
                            });
                          } else {
                            alert(
                              "You do not have permission to view this content"
                            );
                          }
                        }}
                      >
                        View Regions
                      </Button>
                    </CardFooter>
                  </DashboardListingDisplayCard>
                </GridItem>
              </>
            ) : null}
          </GridContainer>

          <GridContainer spacing={3} style={{ marginTop: "20px" }}>
            <GridItem xs={12} sm={6} md={6} lg={6}>
              <DashboardListingDisplayCard
                title="BROKERS"
                style={{ borderRadius: "12px", overflow: "hidden" }}
              >
                <Row style={{ marginBottom: "16px" }}>
                  <Col md="12">
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px"
                    }}>
                      <i
                        className="now-ui-icons users_circle-08"
                        style={{
                          fontSize: "20px",
                          color: STYLES.PRIMARY_APP_CLR,
                          marginRight: "10px"
                        }}
                      />
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Total Branch Brokers:{" "}
                        <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                          {brokerList.length}
                        </span>
                      </span>
                    </div>
                  </Col>
                  <hr style={{ width: "100%", margin: "10px 0" }} />
                  {brokerList.map((broker) => {
                    return (
                      <div key={broker.id}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "10px 0",
                            padding: "8px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "6px"
                          }}
                        >
                          <div style={{ width: "50%" }}>
                            <span style={{ fontSize: "16px", color: "#495057", fontWeight: "500" }}>
                              {`${broker.firstName} ${broker.lastName}`}
                            </span>
                          </div>
                          <div style={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
                            <Button
                              variant="outlined"
                              style={{
                                borderColor: STYLES.PRIMARY_APP_CLR,
                                color: STYLES.PRIMARY_APP_CLR,
                                borderRadius: "6px",
                                fontWeight: "600",
                                padding: "6px 12px",
                                fontSize: "14px"
                              }}
                              onClick={() => {
                                if (
                                  auth.info.profile.adminHomeOffice === branch
                                ) {
                                  navigate("/BrokerProfile", {
                                    state: broker,
                                  });
                                } else {
                                  alert(
                                    "You do not have permission to view this content"
                                  );
                                }
                              }}
                            >
                              Profile
                            </Button>
                          </div>
                        </div>
                        <hr style={{ width: "100%", margin: "10px 0" }} />
                      </div>
                    );
                  })}
                </Row>
              </DashboardListingDisplayCard>
            </GridItem>

            <GridItem xs={12} sm={6} md={6} lg={6}>
              <DashboardListingDisplayCard
                title="ADMINS"
                style={{ borderRadius: "12px", overflow: "hidden" }}
              >
                <Row style={{ marginBottom: "16px" }}>
                  <Col md="12">
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px"
                    }}>
                      <i
                        className="now-ui-icons users_single-02"
                        style={{
                          fontSize: "20px",
                          color: STYLES.PRIMARY_APP_CLR,
                          marginRight: "10px"
                        }}
                      />
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Total Branch Admins:{" "}
                        <span style={{ color: STYLES.SECONDARY_APP_CLR }}>
                          {adminList.length}
                        </span>
                      </span>
                    </div>
                  </Col>
                  <hr style={{ width: "100%", margin: "10px 0" }} />
                  {adminList.map((admin) => {
                    return (
                      <div key={admin.id}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "10px 0",
                            padding: "8px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "6px"
                          }}
                        >
                          <div style={{ width: "50%" }}>
                            <span style={{ fontSize: "16px", color: "#495057", fontWeight: "500" }}>
                              {`${admin.firstName} ${admin.lastName}`}
                            </span>
                          </div>
                          <div style={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
                            <Button
                              variant="outlined"
                              style={{
                                borderColor: STYLES.PRIMARY_APP_CLR,
                                color: STYLES.PRIMARY_APP_CLR,
                                borderRadius: "6px",
                                fontWeight: "600",
                                padding: "6px 12px",
                                fontSize: "14px"
                              }}
                              onClick={() => {
                                if (
                                  auth.info.profile.adminHomeOffice === branch
                                ) {
                                  navigate("/BrokerProfile", {
                                    state: admin,
                                  });
                                } else {
                                  alert(
                                    "You do not have permission to view this content"
                                  );
                                }
                              }}
                            >
                              Profile
                            </Button>
                          </div>
                        </div>
                        <hr style={{ width: "100%", margin: "10px 0" }} />
                      </div>
                    );
                  })}
                </Row>
              </DashboardListingDisplayCard>
            </GridItem>
          </GridContainer>
        </GridItem>
      </Row>
    </div>
  );
};

export default Dashboard;